import React from "react"
import ScheduleList from "../../../components/schedule/schedule_list/ScheduleList"
import { EScheduleListType, IJobDocument, IClientDocument } from "../../../models"

interface IProps {
    job: IJobDocument
	readonly: boolean
}

const JobDetailSchedule: React.SFC<IProps> = (props: IProps) => {
	return (
		<ScheduleList
			readonly={props.readonly}
			type={EScheduleListType.JobSchedule}
            job={props.job}
			client={props.job.ClientId && { Id: props.job.ClientId, Name: props.job.ClientName } as IClientDocument}
		/>
	)
}

export default JobDetailSchedule